import React, { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { TextField } from "@mui/material";
import axios from "axios";
import { FormControl } from "@mui/material";
import UploadIcon from "@mui/icons-material/Upload";

const VideoUploadModal = () => {
  const URL =
    "https://7168661e-436d-4a67-bc22-cb1049597751.mock.pstmn.io/v1/videos";
  const initialFormData = {
    videoLink: "",
    title: "",
    genre: "",
    contentRating: "",
    releaseDate: "",
    previewImage: "",
  };
  const [formData, setFormData] = useState(initialFormData);
  const [open, setOpen] = useState(false);
  const [copyOfDate, setCopyOfDate] = useState("");
  const handleModalOpen = () => {
    setOpen(true);
  };
  const handleModalClose = () => {
    setFormData(initialFormData);
    setOpen(false);
  };
  function handleChange(event) {
    const { id, value } = event.target;
    setCopyOfDate(value);
    
    if (id === "releaseDate") {
      const date = new Date(value);
      const formattedDate = date.toLocaleDateString("en-GB", {
        day: "numeric",
        month: "short",
        year: "numeric",
      });
      setFormData({ ...formData, [id]: formattedDate });
    } else {
      setFormData({ ...formData, [id]: value });
    }
  }

  async function handleUploadVideo(formData) {
    console.log("Uploading Video");
    try {
      const response = await axios.post(URL, formData);
      console.log("response on sending videoUpload", response);
      setFormData(initialFormData);
    } catch (error) {}
  }
  console.log('copyOfDate is', copyOfDate)
  // console.log("formData", formData);
  return (
    <div>
      <Button
        startIcon={<UploadIcon />}
        variant="contained"
        color="secondary"
        sx={{ padding: "4px 10px" }}
        onClick={handleModalOpen}
      >
        Upload
      </Button>
      <Dialog open={open} onClose={handleModalClose}>
        <DialogTitle color="primary">Video Upload</DialogTitle>
        <DialogContent>
          <FormControl onChange={handleChange}>
            <TextField
              id="videoLink"
              autoFocus
              margin="dense"
              label="Video Link"
              type="url"
              helperText="This link will be used to describe the video"
              value={formData.videoLink}
              fullWidth
              variant="outlined"
            />
            <TextField
              id="previewImage"
              margin="dense"
              label="Thumbnail Image Link"
              type="url"
              helperText="This link will be used to preview the thumbnail image"
              value={formData.previewImage}
              fullWidth
            />
            <TextField
              id="title"
              margin="dense"
              label="Title"
              type="text"
              helperText="This title will be the representative text for the video"
              value={formData.title}
              fullWidth
            />
            <TextField
              id="genre"
              margin="dense"
              label="Genre"
              type="text"
              helperText="Genre will help in categorising your video"
              value={formData.genre}
              fullWidth
            />
            <TextField
              id="contentRating"
              margin="dense"
              label="Suitable age group for the clip"
              type="text"
              helperText="This will be used to filter videos on age group suitability"
              value={formData.contentRating}
              fullWidth
            />
            <TextField
              id="releaseDate"
              margin="dense"
              label="Release date"
              type="date"
              helperText="This will be used to sort the videos"
              value={copyOfDate}
              fullWidth
            />
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button variant="text" onClick={handleModalClose} color="primary">
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              handleUploadVideo(formData);
            }}
            color="action"
          >
            Upload Video
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default VideoUploadModal;
